import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API_BASE, timeout: 30000 });

export const api = {
  searchTickers: async (q, assetType) => {
    const params = { q };
    if (assetType) params.asset_type = assetType;
    const { data } = await client.get(`/market/search`, { params });
    return data.results || [];
  },
  quote: async (assetType, symbol) => {
    const { data } = await client.get(`/market/quote/${assetType}/${encodeURIComponent(symbol)}`);
    return data;
  },
  history: async (assetType, symbol, days = 180) => {
    const { data } = await client.get(`/market/history/${assetType}/${encodeURIComponent(symbol)}`, {
      params: { days },
    });
    return data.bars || [];
  },
  analysis: async (assetType, symbol, days = 180) => {
    const { data } = await client.get(`/market/analysis/${assetType}/${encodeURIComponent(symbol)}`, {
      params: { days },
    });
    return data;
  },
  aiAnalysis: async (assetType, symbol, days = 180) => {
    const { data } = await client.post(
      `/market/ai-analysis/${assetType}/${encodeURIComponent(symbol)}`,
      null,
      { params: { days } }
    );
    return data;
  },
  overview: async () => (await client.get(`/market/overview`)).data,
  listWatchlist: async () => (await client.get(`/watchlist`)).data,
  liveWatchlist: async () => (await client.get(`/watchlist/live`)).data,
  addToWatchlist: async (payload) => (await client.post(`/watchlist`, payload)).data,
  removeFromWatchlist: async (id) => (await client.delete(`/watchlist/${id}`)).data,
  listAlerts: async (limit = 50) =>
    (await client.get(`/alerts`, { params: { limit } })).data,
  clearAlerts: async () => (await client.delete(`/alerts`)).data,
};
